"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hint = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const create_use_styles_1 = __importDefault(require("../../theming/create-use-styles"));
function validationStyle(valid, { colors }) {
    switch (valid) {
        case true:
        case "valid":
            return {
                color: colors.success,
            };
        case false:
        case "invalid":
            return {
                color: colors.error,
            };
        default:
            return {};
    }
}
const useStyles = (0, create_use_styles_1.default)(theme => {
    const { spacing, typography } = theme;
    return {
        hint: ({ valid }) => (0, lodash_merge_1.default)({
            gridColumn: "input-start / input-end",
            marginTop: spacing("xs"),
            fontSize: typography.label.fontSize,
        }, validationStyle(valid, theme)),
    };
});
exports.Hint = react_1.default.forwardRef(function Hint({ children, className, valid, ...props }, ref) {
    const classes = useStyles({ valid });
    return (react_1.default.createElement("small", { ref: ref, className: (0, classnames_1.default)(classes.hint, className), ...props }, children));
});
exports.default = exports.Hint;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGludC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2NvbXBvbmVudHMvZm9ybS1ncm91cC9oaW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrREFBMEI7QUFDMUIsNERBQW9DO0FBQ3BDLGdFQUFpQztBQUdqQyx3RkFBOEQ7QUFXOUQsU0FBUyxlQUFlLENBQUMsS0FBc0IsRUFBRSxFQUFFLE1BQU0sRUFBUztJQUNoRSxRQUFRLEtBQUssRUFBRTtRQUNiLEtBQUssSUFBSSxDQUFDO1FBQ1YsS0FBSyxPQUFPO1lBQ1YsT0FBTztnQkFDTCxLQUFLLEVBQUUsTUFBTSxDQUFDLE9BQU87YUFDdEIsQ0FBQztRQUNKLEtBQUssS0FBSyxDQUFDO1FBQ1gsS0FBSyxTQUFTO1lBQ1osT0FBTztnQkFDTCxLQUFLLEVBQUUsTUFBTSxDQUFDLEtBQUs7YUFDcEIsQ0FBQztRQUNKO1lBQ0UsT0FBTyxFQUFFLENBQUM7S0FDYjtBQUNILENBQUM7QUFFRCxNQUFNLFNBQVMsR0FBRyxJQUFBLDJCQUFlLEVBQUMsS0FBSyxDQUFDLEVBQUU7SUFDeEMsTUFBTSxFQUFFLE9BQU8sRUFBRSxVQUFVLEVBQUUsR0FBRyxLQUFLLENBQUM7SUFFdEMsT0FBTztRQUNMLElBQUksRUFBRSxDQUFDLEVBQUUsS0FBSyxFQUFjLEVBQUUsRUFBRSxDQUM5QixJQUFBLHNCQUFLLEVBQ0g7WUFDRSxVQUFVLEVBQUUseUJBQXlCO1lBQ3JDLFNBQVMsRUFBRSxPQUFPLENBQUMsSUFBSSxDQUFDO1lBQ3hCLFFBQVEsRUFBRSxVQUFVLENBQUMsS0FBSyxDQUFDLFFBQVE7U0FDcEMsRUFDRCxlQUFlLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQyxDQUM5QjtLQUNKLENBQUM7QUFDSixDQUFDLENBQUMsQ0FBQztBQUVVLFFBQUEsSUFBSSxHQUFHLGVBQUssQ0FBQyxVQUFVLENBQXlCLFNBQVMsSUFBSSxDQUFDLEVBQUUsUUFBUSxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsR0FBRyxLQUFLLEVBQUUsRUFBRSxHQUFHO0lBQ3RILE1BQU0sT0FBTyxHQUFHLFNBQVMsQ0FBQyxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7SUFFckMsT0FBTyxDQUNMLHlDQUFPLEdBQUcsRUFBRSxHQUFHLEVBQUUsU0FBUyxFQUFFLElBQUEsb0JBQVUsRUFBQyxPQUFPLENBQUMsSUFBSSxFQUFFLFNBQVMsQ0FBQyxLQUFNLEtBQUssSUFDdkUsUUFBUSxDQUNILENBQ1QsQ0FBQztBQUNKLENBQUMsQ0FBQyxDQUFDO0FBRUgsa0JBQWUsWUFBSSxDQUFDIn0=